import React, { useState } from "react";

import styled, { css } from "styled-components";
import Particles from "react-tsparticles";

import Container from "../components/Container";
import WallContainer from "../components/WallContainer";
import Wall from "../components/Wall";

// import title from "../img/title3.svg";
import title from "../img/logo_main.png";
import logo from "../img/logo_lib.png";

import { ReactComponent as CloseIcon } from "../img/icon_close.svg";
import wall1 from "../img/wall1.jpg";
import wall2 from "../img/wall2.jpg";
import title1 from "../img/illust_paint.png";
import title2 from "../img/illust_photo.png";

const options = {
  background: {
    color: "#FFEB6F",
  },
  fpsLimit: 100,
  interactivity: {
    detectsOn: "canvas",
    events: {
      onClick: {
        enable: true,
        mode: "push",
      },
      onHover: {
        enable: true,
        mode: "repulse",
      },
      resize: true,
    },
    modes: {
      bubble: {
        distance: 400,
        duration: 2,
        opacity: 0.8,
        size: 40,
      },
      push: {
        quantity: 4,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
    },
  },
  particles: {
    color: {
      value: ["#4FB2AB", "#EC898E", "#905B9E", "#E64C29", "#69A71B"],
    },
    links: {
      enable: false,
    },
    collisions: {
      enable: true,
    },
    move: {
      direction: "none",
      enable: true,
      outMode: "bounce",
      random: false,
      speed: 0.5,
      straight: false,
    },
    number: {
      density: {
        enable: true,
        value_area: 800,
      },
      value: 40,
    },
    opacity: {
      value: 0.7,
    },
    shape: {
      type: "circle",
    },
    size: {
      random: true,
      value: 20,
    },
  },
  detectRetina: true,
  fullScreen: {
    enable: true,
    zIndex: -1,
  },
};

const TitleCon = styled.div`
  width: 100%;
  text-align: center;
  img {
    width: 50%;
  }
  margin-top: -2rem;
  margin-bottom: 4rem;

  @media (max-width: 768px) {
    img {
      width: 70%;
    }
    margin-bottom: 1.5rem;
  }
`;

const LogoCon = styled.div`
  width: 100%;
  text-align: center;
  img {
    height: 50px;
  }
  margin-top: 3rem;
  @media (max-width: 767.98px) {
    img {
      height: 30px;
    }
    padding-bottom: 50px;
  }
`;

const BrowserAlert = styled.div`
  width: 100%;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #e88f00;
  .txt {
    font-size: 1.1rem;
    font-weight: bold;
    color: white;
  }
  .close {
    fill: white;
    width: 20px;
  }

  ${(props) =>
    !props.visible &&
    css`
      display: none;
    `}
`;

const wallContents = [
  {
    id: 1,
    title: "독서 감상 그리기 대회 수상작",
    imgTitle: title1,
    imgMain: wall1,
    link: "/awards/award1",
  },
  {
    id: 2,
    title: "집콕 책읽기 사진 공모전 수상작",
    imgTitle: title2,
    imgMain: wall2,
    link: "/awards/award2",
  },
];

function Home(props) {
  const [alert, setAlert] = useState(true);
  return (
    <>
      <Particles id="tsparticles" options={options} />
      <BrowserAlert visible={alert}>
        <div className="txt">
          본 홈페이지는 IE(인터넷 익스플로러)를 제외한 크롬 등 기타 브라우저에
          최적화되어 있습니다.
        </div>
        <CloseIcon fill="white" onClick={() => setAlert(false)} />
      </BrowserAlert>
      <Container flex home>
        <TitleCon>
          <img src={title} alt="img" />
        </TitleCon>
        <WallContainer>
          {wallContents.map((content) => (
            <Wall key={content.id} content={content} />
          ))}
        </WallContainer>
        <LogoCon>
          <img src={logo} alt="img" />
        </LogoCon>
      </Container>
    </>
  );
}

export default Home;
